import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title, Meta } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pitstop',
  templateUrl: './pitstop.component.html',
  styleUrls: ['./pitstop.component.css']
})
export class PitstopComponent implements OnInit {

  branchLocator: any[] = [];
  postcode: string = '';
  visible: boolean = false;
  isAuto: boolean = false;

  constructor(
    private spinner: NgxSpinnerService,
    private route: Router,
    private apiService: ApiService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    this.spinner.show();

    this.titleService.setTitle(
      'PitStop Locator | Nearest Drop-Off Point | Line Clear Express'
    );

    const metaDesc = this.metaService.getTag('name=description');
    if (!metaDesc) {
      this.metaService.addTags([
        {
          name: 'description',
          content:
            'Our nationwide branches and points in Malaysia. Pick Up; Delivery; Drop-off; Self Collect;'
        }
      ]);
    } else {
      this.metaService.updateTag(
        {
          name: 'description',
          content:
            'Our nationwide branches and points in Malaysia. Pick Up; Delivery; Drop-off; Self Collect;'
        },
        'name=description'
      );
    }

    window.scrollTo(0, 0);
    this.spinner.hide();
  }

  pitstopLocator(): void {
    this.visible = true;
    this.isAuto = true;

    if (!this.postcode || this.postcode.trim().length < 3) {
      Swal.fire('We are sorry', 'Please enter more than 3 characters.', 'info');
      this.visible = false;
      return;
    }

    this.apiService.getPitstopLocator(this.postcode.trim()).subscribe(
      (res: any[]) => {
        if (!res || res.length === 0) {
          Swal.fire('We are sorry.', 'The location cannot be found.', 'error');
          this.branchLocator = [];
          this.visible = false;
          return;
        }
        
        this.branchLocator = res.map((locator: any) => {
          const lat = parseFloat(locator.latitude);
          const lng = parseFloat(locator.longtitude);

          const isValid = !isNaN(lat) && !isNaN(lng) && lat > 0 && lng > 0;

          return {
            ...locator,
            hasNavigation: isValid,
            wazeLink: isValid
              ? `waze://?ll=${lat},${lng}&navigate=yes`
              : '',
            googleMapLink: isValid
              ? `https://maps.google.com?q=${lng},${lat}`
              : ''
          };
        });
   
        this.visible = false;
      },
      error => {
        this.visible = false;
        Swal.fire(
          'Backend Error!',
          `Error : <small style='color:red;font-style:italic;'>${error.error?.message || 'Unknown error'}</small>`,
          'error'
        );
      }
    );

    this.postcode = '';
  }
}
